import { render } from "./hint.vue?vue&type=template&id=44c37394&ts=true"
import script from "./hint.ts?vue&type=script&lang=ts"
export * from "./hint.ts?vue&type=script&lang=ts"

import "./hint.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__